import { Component, OnInit, Input, ChangeDetectorRef, Output, EventEmitter } from '@angular/core';
import { ModalController } from '@ionic/angular';
import { SkuDataService } from 'src/app/services/sku-data.service';
import { SubjectService } from 'src/app/services/subject.service';
import { UtilitiesService } from 'src/app/utilities/utilities.service';
import { AppSettings } from 'src/app/enums/app-settings.enum';
import { TranslateService } from '@ngx-translate/core';
import { Router, ActivatedRoute } from '@angular/router';
import { ArenaProDataService } from 'src/app/services/arena-pro-data.service';

@Component({
  selector: 'app-arena-pro-gaming-error',
  templateUrl: './arena-pro-gaming-error.component.html',
  styleUrls: ['./arena-pro-gaming-error.component.scss']
})
export class ArenaProGamingErrorComponent implements OnInit {
  @Input('devices') selectedDevice: any;
  @Output() onClickSubscribe = new EventEmitter<any>();
  @Output() backToOptinalDevices = new EventEmitter<any>();
  sku: any;
  constructor(private modalController: ModalController, private SS: SubjectService, private APDS: ArenaProDataService,
    private SKUDS: SkuDataService) {
    this.SS.reloadDevicesList.subscribe((r) => {
      if (r == true) {
        setTimeout(() => {

          this.selectedDevice = null;
          this.selectedDevice = JSON.parse(sessionStorage.getItem('SELECTED_DEVICES'))//this.APDS.selectedData;
        }, 300);
      }
    })
  }

  ngOnInit(): void {
    this.selectedDevice =  JSON.parse(sessionStorage.getItem('SELECTED_DEVICES'))//this.APDS.selectedData;
    this.sku = this.SKUDS.get();
    console.log(this.APDS.selectedData)
    
  }
  dismiss() {
    this.modalController.dismiss();
  }

  subscribeAddon(){
    this.SS.arenaProAddonSelectType.next({'type':'Addon','data':''})
    this.onClickSubscribe.emit({'type':'Addon','data':''})
  }
    
  goBackToOptinalDevice(){
    this.APDS.selectedData = [];
    sessionStorage.removeItem('SELECTED_DEVICES')
    this.SS.arenaProAddonBackToOptinalDevices.next(true)
    this.backToOptinalDevices.emit(true)
  }
}
